import config, { Env } from '@/config';

export default () => {
  return config.mode === Env.production;
};
